/**
 *
 *
 *
 *
 *
 */

import { o_util } from "../common/namespaces";
import type { GlobalUtils } from "../exports/index.js";

export type { SamesiteValues, SetCookieOptions, RemoveCookieOptions } from "../lib/cookie/head.js";

/**
 *
 */
export type CookieSync = GlobalUtils["cookie"];

/**
 *
 *
 *
 */
export const cookie: CookieSync = o_util.cookie;

/**
 *
 */
export const cookieSync: CookieSync = o_util.cookie;
